import { makeStyles } from "@material-ui/core";

const useConfDataStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  cards: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
    },
  },
  footer: {
    backgroundColor: theme.palette.secondary.main,
    width: "100%",
  },
}));

export { useConfDataStyle };
